// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body::after{position:absolute;content:\"\";background-image:url(\"/static/image/bluugo/Logo_norm.png\");width:128px;height:128px;bottom:0.5rem;right:1rem;background-size:contain;background-repeat:no-repeat;background-position:0 100%;opacity:0.1;z-index:-1}.view{display:flex;flex-direction:column;height:100%}.view>.view-content{flex-grow:1;flex-shrink:1;overflow-y:auto;height:100%}.view>.view-footer{position:relative;z-index:1}\n", ""]);
// Exports
module.exports = exports;
